import {
  LatestSensorData,
  LatestSiteData,
} from 'src/app/shared/interfaces/latest-site-data';
import { UtilFunctions } from 'src/app/shared/utils/util-functions';

import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';

import { SiteDetailTiltSensorsService } from './site-detail-tilt-sensors.service';

@Component({
  selector: 'app-site-detail-tilt-sensors',
  templateUrl: './site-detail-tilt-sensors.component.html',
  styleUrls: ['./site-detail-tilt-sensors.component.scss'],
})
export class SiteDetailTiltSensorsComponent implements OnChanges, OnDestroy {
  constructor(private siteDetailSensorsService: SiteDetailTiltSensorsService) {}

  @Input() latestSiteData: LatestSiteData | null = null;

  sensorData: LatestSensorData | undefined = undefined;

  ngOnChanges(changes: SimpleChanges): void {
    this.setSensorData();
  }

  setSensorData(): void {
    if (this.latestSiteData?.sensorData !== undefined) {
      this.sensorData = this.latestSiteData?.sensorData;
    }
  }

  ngOnDestroy(): void {}
}
